// Token storage and current-user fetching.
//
// Tokens live in localStorage under `dreambook.token` so a full page reload
// keeps the session. An in-memory cache avoids touching localStorage on every
// API call.

const KEY = "dreambook.token";
let memo: string | null = null;

export function getToken(): string | null {
  if (memo !== null) return memo;
  try {
    memo = window.localStorage.getItem(KEY);
  } catch {
    memo = null;
  }
  return memo;
}

export function setToken(token: string): void {
  memo = token;
  try {
    window.localStorage.setItem(KEY, token);
  } catch {
    /* ignored — sessionless fallback is OK */
  }
}

export function clearToken(): void {
  memo = null;
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    /* ignored */
  }
}

export interface CurrentUser {
  id: string;
  email: string;
  name: string | null;
  role: "user" | "admin";
  // Billing state mirrored from /api/auth/me. "free" by default.
  plan: "free" | "author" | "studio";
  subscription_status: string | null;
  // "stripe" | "razorpay" | null. Drives which portal/cancel control the
  // Account page renders.
  billing_provider: "stripe" | "razorpay" | null;
  stripe_customer_id: string | null;
  razorpay_customer_id: string | null;
  razorpay_subscription_id: string | null;
  created_at: string;
}
